export enum Mod {
  BARISTA = 'barista',
  DEBUTANT = 'debutant'
}